import { useDetailProgramPageStore } from "@/stores/DetailProgramPage";
import { useDetailPageStore } from "@/stores/DetailPage";
import { type RouteLocationNormalized } from 'vue-router';
import { linkItems } from '@/components/Header/types';

const {
	setCurrentItemDetail
} = useDetailPageStore();

const {
	fetchRelatedChannels,
	setCurrentChannel
} = useDetailProgramPageStore();

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized, from: RouteLocationNormalized) => {
	if (import.meta.client) {
		if (from.path === linkItems.player.routerPath) {
			return;
		}

		setCurrentItemDetail(to.params.id as string);

		setCurrentChannel(null);

		fetchRelatedChannels(to.params.id as string);
	}
});